module.exports = __webpack_public_path__ + "static/img/20200518-5.74d7dc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-5.png
// module id = SRWb
// module chunks = 1